export const TRACKING_DESCRIPTION_IDS = {
	WEIGHT: 'WEIGHT',
	WAIST: 'WAIST',
	BODYFAT: 'BODYFAT',
};

export const TrackingDescriptionID = {
	weight: 'WEIGHT',
	waist: 'WAIST',
	bodyFat: 'BODYFAT',
};

export type TrackingDescriptionIDType = 'WEIGHT' | 'WAIST' | 'BODYFAT' | any;
